/** @jsx jsx */
import { jsx } from "@emotion/react";
import { omit } from "lodash/fp";

import { useThemeProps } from "../wsui/base";
import { FeatureBillboardModule } from "../wsui/municipio";

HeroBillboardModule.wsuiConfig = {
  hasCaption: false,
};

export default function HeroBillboardModule(props) {
  props = useThemeProps({
    props,
    name: "MunicipioHeroBillboardModule",
  });
  return <FeatureBillboardModule {...omit(["titleIcon"], props)} />;
}
